import { render, staticRenderFns } from "./ResearchRow.vue?vue&type=template&id=1698330d&scoped=true"
import script from "./ResearchRow.vue?vue&type=script&setup=true&lang=js"
export * from "./ResearchRow.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResearchRow.vue?vue&type=style&index=0&id=1698330d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1698330d",
  null
  
)

export default component.exports